import React from 'react';
import SEO from '@/SEO';

const HTML_CONTENT = `<h1>பீஜ தானம்</h1>
  <mat-accordion>
    <mat-expansion-panel>
              <mat-expansion-panel-header>
                <div class="blankhd">1 - பீஜதானம்- பஞ்சகவ்யம்
     </div></mat-expansion-panel-header>
  <div class="div3">   புண்ணியாகவாசனம் ஆகி, தன்னையும் ப்ரஸவித்த ஸ்திரீ, குழந்தை, க்ரஹம் முதலியவைகளை 
  புண்ணியாகவாசன ஜலத்தால் ப்ரோக்ஷித்த பிறகு, 'ஓம் நமஸதஸே ஆரம்பித்து, ஸ்வீக்ருத்;ய" 
  வரையில் சொல்லி, (நக்ஷத்ரே ராசௌ ஜாதஸ்ய அல்லது ஜாதாயா: (மம என்று சொல்லச் சொல்லி) 
  'சிசோ: தந்மாதா பித்ரோச்ச மாதுலஸ்ய மாதாமஹாதீனாம்ச ஆயு: அபிவ்ருத்யர்த்தம் ஸர்வாரிஷ்ட 
  சாந்தியர்த்தம் ஸர்வாபீஷ்ட ஸித்யர்த்தம் ஸமஸ்த மங்களாவாப்யாத்தம் ஸமஸ்த ரோகபீடாபரிஹாரார்த்தம் 
  சதாயு: ஸம்பூர்ணதா ஸித்யார்த்தம் வேதோக்த ஆயுர்அபிவிருத்தியர்த்தம் ஏபி: ஸ்ரீவைஷ்ணவைஸ்ஸஹ 
  பீஜதானம் கர்த்தம் யோக்கியதா ஸித்திம் அனுக்ரஹாணா"  'ததாஸ்து யோக்கியதாஸித்திரஸ்து" என்று ப்ரதிவசனம்; பெற்று, 
  படியில் உட்கார்ந்து கொண்டு, விஷ்வக்ஸேன ஆராதனம் செய்து ஸ்ரீ கோவிந்தேத்;யாதி ஆரம்பித்து வேதோத்த ஆயு: 
  அபிவிருத்யர்த்தம் வரை மேலே உள்ளபடி சொல்லி (2 ஆவர்த்தி) 'பீஜாதானம் கரிஷ்யே" என்று ஸங்கல்பம் செய்து
   இடுக்கு தர்ப்பத்தை வடக்கே சேர்க்கவும். விஷ்வக்ஸேனரை யதாஸ்தானம் செய்து (10வது அயிட்டத்தில் சொல்லியபடி) 
   பெரியோர்கள் அனுக்ரஹம் பெற்று (3வது அயிட்டத்தில் சொல்லிபடிசெய்து) க்ரஹப்ரீதி
  </div>      
    
    </mat-expansion-panel >
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <div class="blankhd">2 பீஜ தானம்
</div></mat-expansion-panel-header><div class="div3"> 
விரைக்கு வைத்திருக்கும் நெல்லு,  வெற்றிலை பாக்கு, தக்ஷிணை எல்லாம் தாம்பாளத்தில் எடுத்துக்கொண்டு, 
        'தன்யம் கரோதி தாதாரம் இஹலோகே பரத்ருச ப்ராணிநாம் ஜீவனம்தான்யம் அதச்சாந்திம் ப்ரயச்சமே ஹிரண்ய 
        கர்ப்ப கர்ப்பஸ்தம் ஹேமபூஜம் விபாவஸோ: அனந்த புண்ய பலதம் அதச்சாந்திம் ப்ரயச்சமே நக்ஷத்ரே ஆரம்பித்து 
        பீஜதானம் வரையில் சொல்லி யக்கிஞ்சித் ஹிரண்ய ஸகித இதம் பீஜம் நாநாகோத்ரேப்ய: ஸ்ரீ வைஷ்ணவேப்ய: தேப்ய: 
        தேப்ய: ஸம்ப்ரததே நம: நமம அச்சுத ப்ரியதாம், நெல்லில் பணத்தைப் போட்டு ஸ்ரீ வைஷ்ணவர்களுக்கும் மற்றும்
         உள்ளவர்களுக்கும் கொடுக்க வேண்டியது.</div> 

</mat-expansion-panel >
<mat-expansion-panel>
  <mat-expansion-panel-header>
    <div class="blankhd">3 ஸம்ப்ரதாயம்
</div></mat-expansion-panel-header><div class="div3"> 
மேல் உத்திரியத்தில் மேற்படி தான்யம்வாங்கி பூமியில் நெல்லையும் பணத்தையும் சோத்து, பணத்தை தேடி எடுக்கிற
         ஸம்பிரதாயம், ஆசீர்வாதம் செய்து, வேஷ்டி ஓதிவிட்டு ஸதஸ்க்கு தாம்பூலம் தக்ஷிணை ஸமர்ப்பிவித்து, 
         ப்ருஹஸ்பதி ஸம்பாவனை செய்து மஞ்சள் நீர்; ஆலத்தியெடுத்து படி களையவேண்டியது, ஆசமனம் பவித்திரம் 
         முடிச்சு அவிழ்த்து ஆசமனம் செய்து பெரியோர்களை ஸேவிக்கிறது வழக்கம்.
 </div>

</mat-expansion-panel >
<mat-expansion-panel>
  <mat-expansion-panel-header>
    <div class="blankhd">4 - சில குறிப்புகள்
</div></mat-expansion-panel-header><div class="div3"> 
ப்ரஸவித்த ஸ்த்ரிக்கு புருஷ குழந்தையானால் 21 நாளிலும் பெண்குழந்தை ஆனால் 22 நாளிலும் பஞ்ச 
        கவ்யம் சேர்த்து கொடுக்கிறது. புருஷப்ரஜைக்கு 20வது நாளிலும், ஸ்த்ரீ ப்ரஜைக்கு 40 நாளிலும் பஞ்சகவ்யம் 
        சேர்;த்து கொடுத்து பெருமாளுக்கு திருவாராதனம் செய்து, பெருமாள் தீர்த்தம் ஆசாரியன் பாதுகை அல்லது 
        பெரியோர்கள் ஸ்ரீபாத தீர்த்தம் சேர்த்து கொடுத்து, பாண்ட ஸ்பாசம் (சட்டி தொடுகிறது) செய்கிறது பெரியோர்கள் சம்பிரதாயம். 
        அதுவரையில் அவர்கள் தளிகைசெய்யக்கூடாது. பிறர்களுக்கு எதுவும் கொடுக்கக்கூடாது. 
        அவர்களுக்கு மேற்படி காலம் வரையில் ப்ரஸவ தீட்டு உண்டு.
  </div>

</mat-expansion-panel >
<mat-expansion-panel>
  <mat-expansion-panel-header>
    <div class="blankhd">5 பஞ்சகவ்ய ஸம்மேளனம்
</div></mat-expansion-panel-header><div class="div3"> 

பாத ப்ரக்ஷhளனம்<br /> 
ஆசமனம்<br /> 
ஓம் அஸ்மத் குருப்யோ நம: .... சுக்லாம்பரதரம் ... தமாச்ரயே.<br /> 
ஹரிரோம்தது ஸ்ரீகோவிந்தா ..... அஸ்யாம் சுப திதௌ ஸ்ரீபகவதாஜ்ஞயா பகவத் கைங்கர்ய ரூபம் 
(ஸ்ரீமந்  நாராயண ப்ரீத்யர்த்தம்) கோத்ரஸ்ய சர்மண: (அல்லது கோத்ராயா: நாம்நீயா:) சாPர சுத்யர்த்தம்
 பஞ்சகவ்ய சம்மேளனம் கரிஷ்யே.<br /> 
என்று சங்கல்பம் (ஸாத்விக த்யாகம்) பண்ணிக்கொண்டு <br /> 
கிழக்குப் பார்க்க அமர்ந்து தனக்கு முன்னால் கோலம்போட்ட இடத்தில் நெல்லை பரப்பி 
அதன்மேல் கொஞ்சம் தர்பங்களைப் போட்டு பெருமாள் ஆராதனத்திற்குப்போல் 5 கிண்ணங்களை   
 நடுவில் ஒன்றும் கிழக்கு, தெற்கு, மேற்கு, வடக்கு ஆகிய திக்குகளில் ஒவ்வொன்றும் வைக்கவேண்ம்.<br /> 
 
1. நடு கிண்ணத்தில் பால் 5 மடங்கு<br /> 
2. கிழக்கில் தயிர் 3 மடங்கு<br /> 
3. தெற்கில் பசு நெய் இரண்டரை மடங்கு<br /> 
4. மேற்கில் பசு மூத்திரம் ஒரு மடங்கு<br /> 
5. வடக்கில் பசும் சாணி (கோமயம்) துளி (கால் பங்கு)<br /> 
<br /> 
ஆறாவதாக வடகிழக்கில் ஒரு கிண்ணத்தில் தீர்த்தம் வைத்து அதில் தர்பத் துண்டுகளை போட்டு வைக்கவேண்டும்.<br /> 
<br /> 
1. பாலில் க்ஷPராதி தைவதம் ஸோமம் ஆவாஹயாமி<br /> 
2. தயிரில் தத்யாதி தைவதம் ப்ரஹ்மாணம் ஆவாஹயாமி<br /> 
3. நெய்யில் க்ருதாதி தைவதம் வாயும் ஆவாஹயாமி<br /> 
4. கோமூத்ரத்தில் கோமூத்ராதி தைவதம் ருத்ரம் ஆவாஹயாமி<br /> 
5. கோமயத்தில் கோமயாதி தைவதம் (யஜ்ஞேசம்) மஹாவிஷ்ணும் ஆவாஹயாமி.<br /> 
6. தர்ப தீர்த்தத்தில் குசாதி தைவதம் வருணம் ஆவாஹயாமி<br /> 
என்று  ஆவாஹனங்களை செய்து.<br /> 
ஆவாஹிதாப்ய: ஸர்வாப்யோ தேவதாப்யோ நம:<br /> 
அர்க்யம் ஸமர்ப்பயாமி<br /> 
பாத்யம் ஸமர்ப்பயாமி<br /> 
ஆசமனீயம் ஸமர்ப்பயாமி<br /> 
ஸ்நாபயாமி<br /> 
ஸ்hநாந அநந்தரம் ஆசமனீயம் ஸமர்ப்பயாமி<br /> 
கந்தாந் தாரயாமி<br /> 
புஷ்பாணி ஸமர்ப்பயாமி<br /> 
தூப தீபார்த்தம், ஆபரணார்த்தம் அலங்காரார்த்தம்<br /> 
அக்ஷதான் ஸமர்ப்பயாமி<br /> 
ஸமஸ்த உபசாரார்த்தம் அக்ஷதான் ஸமர்ப்பயாமி<br /> 
வெத்திலை, பாக்கு, பழம், தக்ஷpணை வைத்து தீர்த்தம் ப்ரோக்ஷpத்து<br /> 
கதலீபலம் நிவேதயாமி<br /> 
கற்பூர தாம்பூலம் ஸமர்ப்பயாமி<br /> 
ஸ்வர்ண புஷ்பம் ஸமர்ப்பயாமி<br /> 
மந்த்ர புஷ்பம் ஸமர்ப்பயாமி<br /> 
ஸமஸ்த உபசரார்த்தம் அக்ஷதான் ஸமர்ப்பயாமி<br /> 
என்று உபசாரங்களை பண்ணிவிட்டு கீழ்கண்டவாறு மந்திரத்துடன் கலக்கவேண்டும்.<br /> 
இரண்டு தர்பத்தால் செய்யப்பட்ட ஒரு ஆயாமத கூர்ச்சத்தை வைத்துக்கொண்டு மற்றொரு 
புதிய பாத்திரத்தில் முதலில் வடக்கில் இருக்கும் கோமயத்தை எடுத்துக்;கெ;hண்டு -- கந்தத்வாராம் 
துராதர்ஷாம் நித்யபுஷ்டாம் காPஷீணீம் ஈச்வரீம் ஸர்வபூதாநாம் த்வாமிஹோபஹ்வயே ச்ரியம் என்று சேர்க்கவும்.<br /> 
அடுத்து - <br /> 
ஆப்யாயஸ்வ ஸமேதுதே விச்வதஸோம வ்ருஷ்ணியம் பவாவாஜஸ்ய ஸங்கதே என்று பாலை அதனுடன் சேர்க்கவும்.<br /> 
அடுத்து<br /> 
ததிக்ராவிண்ணோ அகாரிஷம்  ஜிஷ்ணோரஸ்வஸ்ய வாஜின: சுரபினோ முகாகரது ப்ரண 
ஆயூகும்ஷி தாரிஷது என்று தயிரை விட்டு கலக்கவும்.<br /> 
அடுத்து   -  சுக்ரமஸி ஜோதிரஸி தேஜோஸி என்று நெய்யையும்<br /> 
அடுத்து - தேவஸ்யத்வா ஸவிது:ப்ரசவே அச்விநோர்பாஹுப்யாம் பூஷ்ணோ ஹஸ்தாப்யாம் ... 
என்று தர்ப தீர்த்தத்தையும் விட்டு, வடக்கு நுனியாக ஆயாமதத்தை ப்ரதிக்ரஹ (7வது) பாத்திரத்தில் 
வைத்து,  ‘ஓம்” எனும் ப்ரணவத்தை அநுசந்தித்துக்கொண்டு கலக்கவேண்டும்.<br /> 
கலந்ததை வெளியில் கொண்டுபோய் சூரியனுக்குக் காட்டி : உதுத்யம் ஜாதவேதஸம் தேவம் 
வஹந்தி கேதவ: த்ருசே விச்வாய சூர்யம்...” என்று சொல்லி நிவேதன்போல் காட்டிவிட்டு, 
பெருமாளுக்கும் கண்டருளப்பண்ணி பின் கர்த்தாவோ, ஆத்துக்காரியோ யாருக்கு சுத்தம் 
வேண்டுமோ அவர்கள் முன்போல் மொத்த சங்கல்பமும் சொல்லி கடைசியில் ... கோத்ரஸ்ய சர்மண: 
(கோத்ராயா: நாம்நீயா:) மம சாPர சுத்யர்த்தம் பஞ்சகவ்ய ப்ராசனம் கரிஷ்யே என்று சங்கல்பம் 
(ஸாத்விக த்யாகமும் பண்ணிக்n;காண்டு) <br /> 
யத் த்வகஸ்திகதம் பாபம் தேஹே திஷ்டதி மாமகே<br /> 
ப்ராசனம் பஞ்சகவ்யஸ்ய தஹத்வ அக்நிரிவேந்திரியம்.<br /> 
என்று மந்திரம் சொல்லி 3 தரம் அருந்தவும் (அருந்தச் செய்யவும்). <br /> 
பெருமாள் ஆராதனம் ஆகி, பெருமாள் தீர்த்தம் எடுத்துக்கொண்டபின் பஞ்சகவ்யம் சாப்பிடவேண்டும்.<br /> 
 </div>

</mat-expansion-panel >

    </mat-accordion>`;

const BeejaDhanamPage = () => {
  return (
    <div className="vaideekam-page-container w-full max-w-4xl mx-auto p-4 md:p-6 pb-24">
      <SEO title="பீஜதானம் - Ahobilam" />
      <div 
        className="vaideekam-content bg-white p-6 rounded-xl shadow-sm border border-green-100/50"
        dangerouslySetInnerHTML={{ __html: HTML_CONTENT }} 
      />
    </div>
  );
};

export default BeejaDhanamPage;
